<template>
  <footer class="w-full p-8">
    <p class="font-subtitle text-xs text-white-barely-visible text-center">
      © 2018 DATADEER
    </p>
  </footer>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
